define('fukit/behavior/enable.loading.on.resource.request.behavior',['require','marionette'],function(require) {
  var Mn = require('marionette');

  var EnableLoadingOnResourceRequestBehavior = Mn.Behavior.extend({
    initialize: function() {
      if (this.getResource()) {
        this.bindResourceEvents();
      } else {
        this.once('render', this.bindResourceEvents, this);
      }
    },

    bindResourceEvents: function() {
      var resource = this.getResource();
      this.listenTo(resource, 'request', this.onResourceRequest);
      this.listenTo(resource, 'sync', this.onResourceSync);
      this.listenTo(resource, 'error', this.onResourceError);
    },

    getResource: function() {
      if (this.getOption('resource')) {
        return this.getOption('resource');
      } else if (this.getOption('model')) {
        return this.getOption('model');
      } else if (this.getOption('collection')) {
        return this.getOption('collection');
      } else if (this.view.getOption('model') || this.view.model) {
        return this.view.getOption('model') || this.view.model;
      } else if (this.view.getOption('collection') || this.view.collection) {
        return this.view.getOption('collection') || this.view.collection;
      }
    },

    onResourceRequest: function() {
      this.view.loading = true;
    },

    onResourceSync: function() {
      this.view.loading = false;
    },

    onResourceError: function() {
      this.view.loading = false;
    },
  });

  return EnableLoadingOnResourceRequestBehavior;
});

